import {ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DefaultDraftItem } from '../../../models/default-draft-template.model';

require('./planning-default-drafts-table-row.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-planning-default-drafts-table-row',
  templateUrl: './planning-default-drafts-table-row.html',
})
export class PlanningDefaultDraftsTableRowComponent implements OnInit {
  @Input() draft: DefaultDraftItem;

  // TODO: Restore edit functionality when draft names become editable
  // @Output() editDraft = new EventEmitter<DefaultDraftItem>();
  @Output() deleteDraft = new EventEmitter<DefaultDraftItem>();

  // TODO: Restore edit-related properties when draft names become editable
  // isHovered = false;
  // isEditing = false;
  // editingName = '';

  constructor() {
  }

  ngOnInit() {
  }

  // TODO: Restore mouse event handlers when draft names become editable
  // onMouseEnter(): void {
  //   this.isHovered = true;
  // }

  // onMouseLeave(): void {
  //   this.isHovered = false;
  // }

  // TODO: Restore edit methods when draft names become editable
  // onStartEdit(event: MouseEvent): void {
  //   event.stopPropagation();
  //   this.isEditing = true;
  //   this.editingName = this.draft.name;
  // }

  // onSaveEdit(event: MouseEvent): void {
  //   event.stopPropagation();
  //   const trimmed = this.editingName.trim();
  //   if (trimmed && trimmed !== this.draft.name) {
  //     this.draft.name = trimmed;
  //     this.editDraft.emit(this.draft);
  //   }
  //   this.isEditing = false;
  // }

  // onCancelEdit(event: MouseEvent): void {
  //   event.stopPropagation();
  //   this.isEditing = false;
  //   this.editingName = this.draft.name;
  // }

  onDelete(event: MouseEvent): void {
    event.stopPropagation();
    this.deleteDraft.emit(this.draft);
  }
}
